<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount">
        {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Estorno de compra</strong><br />
        Shopping Casar.com
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>

    <div class="c-base-transaction-details__body">
      <div
        class="columns is-mobile is-gapless is-multiline is-vcentered margin-bottom"
      >
        <div class="column is-half">
          <p class="is-size-6 margin-bottom">
            <strong>
              Estorno de {{ transaction.details.order_item_supplier_name }}
            </strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="is-size-6 has-text-support">
            {{ transaction.details.order_item_price | currency }}
          </strong>
        </div>
        <div class="column is-half">
          <p
            v-if="transaction.details.cashbacked_at !== null"
            class="is-size-6 is-flex"
          >
            <strong>Desconto cashback</strong>
            <span
              class="icon tooltip is-tooltip-multiline"
              data-tooltip="Desconto referente ao bônus gerado na compra dos produtos."
            >
              <base-icon width="1.2em" height="1.2em" name="painel/help-icon" />
            </span>
          </p>
          <p v-else class="is-size-6 is-flex">
            <strong class="has-text-grey has-text-line-through">
              Cashback
            </strong>
            <span
              class="icon has-text-grey tooltip is-tooltip-multiline"
              data-tooltip="Valor de cashback cancelado referente ao reembolso do valor do produto."
            >
              <base-icon width="1.2em" height="1.2em" name="painel/help-icon" />
            </span>
          </p>
        </div>

        <div class="column is-half has-text-right">
          <strong
            v-if="transaction.details.cashbacked_at !== null"
            class="is-size-6 has-text-error"
          >
            -{{ transaction.details.order_item_cashback_amount | currency }}
          </strong>
          <strong v-else class="is-size-6 has-text-grey has-text-line-through">
            {{ transaction.details.order_item_cashback_amount | currency }}
          </strong>
        </div>
        <div class="margin-bottom">
          <a
            @click="
              userValidateToRedirect(
                'details',
                '',
                transaction.details.external_order_id
              )
            "
            class="c-base-transaction-details has-text-underline"
            >Ver detalhes do pedido
            {{ transaction.details.external_order_id }}
          </a>
        </div>
      </div>

      <div
        class="columns border-bottom is-mobile is-gapless is-multiline is-vcentered margin-bottom"
      >
        <div class="column is-full">
          <p class="is-size-6 margin-bottom">
            <strong>Retornos</strong>
          </p>
        </div>
        <div class="column is-half" height="1.5em">
          <p>Para saldo disponível</p>
        </div>
        <div class="column is-half has-text-right">
          <strong>{{ transaction.amount | currency }}</strong>
        </div>
        <div
          v-if="transaction.details.bonus_refunded_amount"
          class="column is-half"
          height="1.5em"
        >
          <p>Para bônus exclusivo</p>
        </div>
        <div
          v-if="transaction.details.bonus_refunded_amount"
          class="column is-half has-text-right"
        >
          <strong>{{
            transaction.details.bonus_refunded_amount | currency
          }}</strong>
        </div>
      </div>

      <a
        v-if="referenceTransaction"
        @click="emitReferenceTransaction"
        class="columns is-vcentered is-mobile is-gapless is-multiline margin-bottom"
        href="#"
      >
        <div class="column">
          <p class="has-text-black margin-bottom">
            Referente à compra realizada em<br />
            <strong> Shopping Casar.com </strong>
            <br />
          </p>
          <p class="has-text-black">
            Em {{ referenceTransaction.created_at | date }}
          </p>
        </div>
        <div class="column has-text-right is-1">
          <base-icon
            width="24px"
            height="24px"
            name="painel/arrow-right-icon"
            class="has-text-grey-dark"
          />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'
import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'
import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [BaseTransactionDetailsMixin, verifyDataUserMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: String,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    transactionsLoadeds: {
      get() {
        return this.$store.state.wallet.transactionsLoadeds
      },
      set(payload) {
        this.$store.dispatch('setTransactionsLoadeds', payload)
      },
    },
  },

  data() {
    return {
      referenceTransaction: null,
    }
  },

  mounted() {
    this.getReferenceTransaction()
  },

  methods: {
    getReferenceTransaction() {
      const reference = this.transactionsLoadeds.find(
        (transaction) =>
          transaction.transaction_id === this.transaction.reference_id
      )
      if (reference) {
        this.referenceTransaction = reference
        return
      }
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getTransaction(this.transaction.reference_id)
        .then((response) => {
          this.referenceTransaction = response.data.data
          this.transactionsLoadeds = this.transactionsLoadeds.concat(
            this.referenceTransaction
          )
          this.referenceTransaction
        })
        .catch(null)
    },

    emitReferenceTransaction() {
      this.$emit('open-reference')
    },

    userValidateToRedirect(params, redirectTypeName, order_id) {
      if (this.verifyDataUser()) {
        this.goTo(params, redirectTypeName, order_id)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>

<style lang="scss">
.has-text-line-through {
  text-decoration: line-through;
}
</style>
